import { $json } from "@voltra/json"
import { identity } from "@/utils/functions"

export default {
    install(Vue, {
        config = identity,
    } = {}){
        config($json);

        Object.defineProperties(Vue.prototype, {
            "$json": {
                get(){ return $json; },
            }
        });
    }
}
